import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between gap-3 p-4 hover:bg-gray-50/40 sm:flex-row sm:items-center" }
const _hoisted_2 = { class: "min-w-0 flex-1" }
const _hoisted_3 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_5 = ["aria-expanded", "aria-controls", "aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "mt-1 flex flex-wrap gap-x-3 gap-y-1 text-xs text-gray-500"
}
const _hoisted_7 = { class: "mr-1 font-medium text-gray-700" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "flex items-center justify-between" }
const _hoisted_10 = { class: "font-medium text-gray-700" }
const _hoisted_11 = ["aria-label"]
const _hoisted_12 = { class: "flex shrink-0 items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString($props.phone.displayPhoneNumber ||
                        $props.phone.phoneNumberId ||
                        $setup.t('whatsappMeta.phone.unidentifiedNumber')), 1 /* TEXT */),
        _createVNode($setup["PhoneNumberEligibilityState"], { phone: $props.policyPhone }, null, 8 /* PROPS */, ["phone"]),
        _createElementVNode("button", {
          type: "button",
          class: "focus-visible:ring-primary inline-flex h-6 w-6 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus-visible:ring-2",
          "aria-expanded": $setup.detailsOpen,
          "aria-controls": $setup.detailsId,
          "aria-label": $setup.t('whatsappMeta.detail.showTechnicalDetails'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.detailsOpen = !$setup.detailsOpen))
        }, [
          _createVNode($setup["InformationCircleIcon"], {
            class: "h-4 w-4",
            "aria-hidden": "true"
          })
        ], 8 /* PROPS */, _hoisted_5)
      ]),
      ($props.policyPhone)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.axes, (axis) => {
              return (_openBlock(), _createElementBlock("span", {
                key: axis.owner,
                class: "flex items-center"
              }, [
                (axis.ok)
                  ? (_openBlock(), _createBlock($setup["CheckCircleIcon"], {
                      key: 0,
                      class: "mr-1 h-4 w-4 text-emerald-500",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock($setup["MinusCircleIcon"], {
                      key: 1,
                      class: "mr-1 h-4 w-4 text-gray-400",
                      "aria-hidden": "true"
                    })),
                _createElementVNode("span", _hoisted_7, _toDisplayString(axis.owner) + ":", 1 /* TEXT */),
                _createTextVNode(" " + _toDisplayString(axis.value), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.detailsOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: $setup.detailsId,
            class: "mt-2.5 space-y-1 rounded-md border border-gray-200 bg-gray-50 p-3 text-xs text-gray-600"
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString($setup.t('whatsappMeta.detail.technicalDetails')), 1 /* TEXT */),
              _createElementVNode("button", {
                type: "button",
                class: "text-gray-400 hover:text-gray-600",
                "aria-label": $setup.t('whatsappMeta.detail.closeTechnicalDetails'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.detailsOpen = false))
              }, [
                _createVNode($setup["XIcon"], {
                  class: "h-3.5 w-3.5",
                  "aria-hidden": "true"
                })
              ], 8 /* PROPS */, _hoisted_11)
            ]),
            _createElementVNode("p", null, _toDisplayString($setup.t('whatsappMeta.detail.verifiedName')) + ": " + _toDisplayString($props.phone.verifiedName || $setup.t('whatsappMeta.phone.noVerifiedName')), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString($setup.t('whatsappMeta.detail.metaPhoneId')) + ": " + _toDisplayString($props.phone.phoneNumberId || $setup.t('whatsappMeta.phone.idUnavailable')), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString($setup.t('whatsappMeta.detail.registrationStatus')) + ": " + _toDisplayString($props.policyPhone?.registrationStatus || $props.phone.registrationStatus), 1 /* TEXT */),
            _createElementVNode("p", null, _toDisplayString($setup.t('whatsappMeta.detail.lastSyncedAt')) + ": " + _toDisplayString($setup.lastSyncedAt), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_8))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_12, [
      ($setup.canActivate && $props.phone.phoneNumberId)
        ? (_openBlock(), _createBlock(_component_UiButton, {
            key: 0,
            variant: "white",
            "text-variant": "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('activate', $props.phone.phoneNumberId)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.t('whatsappMeta.phone.activateOnMeta')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : ($setup.canEnablePhone && $props.policyPhone)
          ? (_openBlock(), _createBlock(_component_UiButton, {
              key: 1,
              variant: "white",
              "text-variant": "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('approval', $props.policyPhone, true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($setup.t('whatsappMeta.phone.enable')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : ($setup.canDisable && $props.policyPhone)
            ? (_openBlock(), _createBlock(_component_UiButton, {
                key: 2,
                variant: "white",
                "text-variant": "red-600",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('approval', $props.policyPhone, false)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('whatsappMeta.phone.disable')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
    ])
  ]))
}